<template>
  <div :class="$style.container">
    <div v-m-b="4" :class="$style.section">
      <span v-text="$t('transaction.tips.bill.amount')"></span>
      <span v-text="displayAmount"></span>
    </div>
    <div v-m-b="4" :class="$style.section">
      <span v-text="$t('transaction.tips.percent')"></span>
      <span v-text="`${variant.percent}%`"></span>
    </div>
    <div :class="$style.section">
      <span v-text="$t('transaction.tips.overall')"></span>
      <span v-text="displayOverall"></span>
    </div>
  </div>
</template>

<script>
import { formatAmount } from 'lib/utils/amount';

export default {
  name: 'AppliedTransactionTips',
  props: {
    variant: {
      type: Object,
      required: true,
    },
  },
  computed: {
    displayAmount() {
      const { amount, currency } = this.variant;

      return formatAmount(amount, currency);
    },
    displayOverall() {
      const { overall, currency } = this.variant;

      return formatAmount(overall, currency);
    },
  },
};
</script>

<style lang="sass" module>
  .container
    padding: 8px
    font-weight: 400
    font-size: 12px
    line-height: 15px
    color: #212121
    border: 1px dashed var(--color-green)
    border-radius: 8px

  .section
    display: flex
    justify-content: space-between

    span
      word-break: keep-all
</style>
